import React from 'react';
export function Footer() {
  return <footer className="bg-white/80 backdrop-blur-sm text-slate-400 py-10 text-center border-t border-slate-200" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <div className="font-black text-black mb-1 tracking-wider uppercase text-sm" data-id="element-87">
          TU SOLUCIÓN DIGITAL™
        </div>
        <p className="text-xs mb-4" data-id="element-88">
          El sistema simple para ordenar tu plata en Argentina sin culpa.
        </p>
        <a href="https://www.tusoluciondigital.shop" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 transition-colors text-xs font-bold" data-id="element-89">
          www.tusoluciondigital.shop
        </a>
        <div className="mt-8 text-xs opacity-40" data-id="element-90">
          &copy; {new Date().getFullYear()} Tu Solución Digital. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}